import React from "react";
import { FullscreenView } from "components/utils/FullscreenView";
import { AclHeader } from "components/acl/AclHeader";
import { AclTable } from "components/acl/AclTable";
import { edstFontDim } from "@poscon/shared-frontend";

export const Acl = () => <FullscreenView view="ACL" HeaderComponent={AclHeader} BodyComponent={AclTable} minWidth={edstFontDim.width * 94} />;
